
import { tail, head, isEmpty, partition } from "../fable-library-js.5.0.0/List.js";
import { createElement } from "react";
import { createObj } from "../fable-library-js.5.0.0/Util.js";
import { class_type } from "../fable-library-js.5.0.0/Reflection.js";

export function SvgHelper_createSvgElement(name, properties) {
    const matchValue = partition((tupledArg) => (tupledArg[0] !== "children"), properties);
    let matchResult, children, props, props_2;
    if (!isEmpty(matchValue[1])) {
        if (head(matchValue[1])[0] === "children") {
            if (isEmpty(tail(matchValue[1]))) {
                matchResult = 0;
                children = head(matchValue[1])[1];
                props = matchValue[0];
            }
            else {
                matchResult = 1;
                props_2 = matchValue[0];
            }
        }
        else {
            matchResult = 1;
            props_2 = matchValue[0];
        }
    }
    else {
        matchResult = 1;
        props_2 = matchValue[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(name, createObj(props), ...children);
        default:
            return createElement(name, createObj(props_2));
    }
}

export class Svg {
    constructor() {
    }
}

export function Svg_$reflection() {
    return class_type("Feliz.Svg", undefined, Svg);
}

export class svg {
    constructor() {
    }
}

export function svg_$reflection() {
    return class_type("Feliz.svg", undefined, svg);
}

/**
 * A unique identifier for the element. Used by React to identify elements.
 */
export function svg_key_Z721C83C5(value) {
    return ["key", value];
}

